<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <daily-box-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import DailyBoxShowData from "./DailyBoxShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "DailyBoxShow",
        components: {CrudShow, DailyBoxShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.dailyBox.showing',
            }
        },
    }
</script>

